import { render } from "./AppPrestitosiTopbar.vue?vue&type=template&id=2a524b21"
import script from "./AppPrestitosiTopbar.vue?vue&type=script&lang=js"
export * from "./AppPrestitosiTopbar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\9consulting-front-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__